/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
(function () {
    function wrapElement(el, wrapper) {
        // Crea un nuovo elemento div
        wrapper = wrapper || document.createElement('div');

        // Inserisci il wrapper prima dell'elemento
        el.parentNode.insertBefore(wrapper, el);

        // Sposta l'elemento all'interno del wrapper
        return wrapper.appendChild(el);
    }

    function isScriptLoaded(src) {
        return document.querySelector(`script[src="${src}"]`) !== null;
    }

    // video into product page
    document.querySelectorAll('.product__block.product__description :not(.product-generic-video) iframe').forEach((element) => {
        let wrapper = document.createElement('div');
        wrapper.classList.add('product-generic-video')
        wrapElement(element, wrapper)
    })
    // accessibility
    const loadAW = (open) => {
        (function () {
            let script_url = "https://acsbapp.com/apps/app/dist/js/app.js";
            let open_fn = () => {
                setTimeout(function () {
                    const el = document.querySelector('.acsb-trigger')
                    if (el) {
                        el.click()
                    } else {
                        open_fn()
                    }
                }, 500);
            }
            if (!isScriptLoaded(script_url)) {
                let s = document.createElement("script"),
                    e = !document.body ? document.querySelector("head") :
                        document.body;
                s.src = script_url;
                s.async = true;
                s.onload = function () {
                    acsbJS.init({
                        statementLink: theme.routes.shop_url + '/pages/accessibility',
                        footerHtml: '<a href="https:www.accessiway.com/">AccessiWay. The Web Accessibility Solution</a>',
                        hideMobile: false,
                        hideTrigger: true,
                        language: "it",
                        position: "left",
                        leadColor: "#f95a6d",
                        triggerColor: "#f44764",
                        triggerRadius: "10%",
                        triggerPositionX: "left",
                        triggerPositionY: "bottom",
                        triggerIcon: "people",
                        triggerSize: "medium",
                        triggerOffsetX: 20,
                        triggerOffsetY: 20,
                        mobile: {
                            triggerSize: "medium",
                            triggerPositionX: "left",
                            triggerPositionY: "bottom",
                            triggerOffsetX: 10,
                            triggerOffsetY: 10,
                            triggerRadius: "50%",
                        },
                    });
                    if (open) {
                        open_fn()
                    }
                };
                e.appendChild(s);
            } else {
                if (open) {
                    open_fn();
                }
            }
        })();
    }
    let accessibility_element = document.querySelector('footer .footer-block:nth-of-type(2) .footer-links li:last-of-type a')
    accessibility_element.innerHTML = "<img class='footer__icon' src='" + theme.assets.base + "/icona-accessibilita.svg' alt='accessibility'/>" + accessibility_element.innerHTML
    document.querySelector('footer .footer-block:nth-of-type(2) .footer-links li:last-of-type').addEventListener("click", (event) => {
        event.preventDefault();
        loadAW(true)
    })
    const gtmSetPosition = function () {
        let productsGrid = document.querySelectorAll('.collection__products, .carousel')
        if (productsGrid) {
            productsGrid.forEach((gridElement) => {
                let allProducts = gridElement.querySelectorAll('.product-grid-item')
                if (allProducts) {
                    allProducts.forEach((element, index) => {
                        element.dataset.gtmPosition = index + 1
                    })
                }
            })
        }
    }
    gtmSetPosition()

    // Stick bar fix
    document.addEventListener("satcbaddtocartloaded", function () {
        var great_copy_btn_selector = "form[action$='/cart/add'] #AddToCart-product-templates, .product-form__item #AddToCart-product-template, form[action$='/cart/add'] .btn--view-cart, form[action$='/cart/add'] [type=submit], form[action$='/cart/add'] .btn--add-to-cart, form[action$='/cart/add'] button.add_to_cart, form[action$='/cart/add'] [type=submit], form[action$='/cart/add'] #addToCart, .Product__Info .addCart, div[data-pf-type='Block'] button[data-pf-type='ProductATC2']";
        var lb_bundle_cta_button_selector = "body .lb-bundle-cta-button";
        var checklbbtninterval = setInterval(checklbbtn, 500);

        function getOffsetTop(el) {
            var offsetTop = 0;
            while (el) {
                offsetTop += el.offsetTop;
                el = el.offsetParent;
            }
            return offsetTop;
        }

        function checklbbtn() {
            var lbBtn = document.querySelector(lb_bundle_cta_button_selector);
            if (lbBtn) {
                clearInterval(checklbbtninterval);

                var greatBtn = getFirstVisibleElementFromSelectors(great_copy_btn_selector);
                if (!greatBtn) return;

                var greatBtnBottom = getOffsetTop(greatBtn) + greatBtn.offsetHeight;
                var lbBtnBottom = getOffsetTop(lbBtn) + lbBtn.offsetHeight;
                var stickyBar = document.querySelector('body #great_sticky_bar');

                window.addEventListener('scroll', function () {
                    var scrollTop = window.scrollY;
                    if (lbBtnBottom > scrollTop) {
                        if (stickyBar) stickyBar.classList.add('stickyhide');
                    } else {
                        if (stickyBar) stickyBar.classList.remove('stickyhide');
                    }
                });
            }
        }

        function getFirstVisibleElementFromSelectors(selectors) {
            var selectorArr = selectors.split(',');
            for (var selector of selectorArr) {
                selector = selector.trim();
                selector = selector.replace(/:first/g, '').replace(/:visible/g, '').trim();
                var el = document.querySelector(selector);
                if (el) {
                    var style = window.getComputedStyle(el);
                    if (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0') {
                        return el;
                    }
                }
            }
            return null;
        }
    });
    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
})();

document.addEventListener("DOMContentLoaded", () => {
    const originalMessage = "You can only submit up to 3 subscriptions per day.";
    const translatedMessage = "Hai già inviato una richiesta per questo prodotto!";

    const observer = new MutationObserver(() => {
      const warningSpans = document.querySelectorAll(".esc-modal-footer-error-message span");
      warningSpans.forEach((el) => {
        if (el.textContent.includes(originalMessage)) {
          el.textContent = translatedMessage;
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

//----- EasyLockdown integration for product grid updates - Start -----//
(function() {
    /**
     * Initialize EasyLockdown filters and hide links after product grid updates
     * This hooks into renderProductGrid functionality without modifying theme.js
     */
    function initEasyLockdown() {
        if (typeof easylockdown === 'object') {
            easylockdown.initFilters();
            easylockdown.hideAllLinks();
        }
    }

    // Store observers to avoid duplicate observations
    const observedContainers = new WeakSet();
    let debounceTimeout = null;

    /**
     * Setup MutationObserver to watch for product grid changes
     * This catches both initial render and AJAX updates from filters/sorting
     */
    function setupProductGridObserver() {
        // Find all product grid containers
        const productGridContainers = document.querySelectorAll('[data-collection-products]');
        
        if (productGridContainers.length === 0) {
            return;
        }

        // Create a debounced callback to avoid multiple rapid calls
        const debouncedInit = function() {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(function() {
                initEasyLockdown();
            }, 150);
        };

        // Observe each product grid container for changes
        productGridContainers.forEach(function(container) {
            // Skip if already observing this container
            if (observedContainers.has(container)) {
                return;
            }
            
            observedContainers.add(container);

            const observer = new MutationObserver(function(mutations) {
                let shouldTrigger = false;
                
                mutations.forEach(function(mutation) {
                    // Check if the product grid content changed
                    if (mutation.type === 'childList') {
                        // Check if product items were added or removed
                        if (mutation.addedNodes.length > 0) {
                            const hasProductItems = Array.from(mutation.addedNodes).some(function(node) {
                                if (node.nodeType !== 1) return false;
                                return node.classList && (
                                    node.classList.contains('product-grid-item') ||
                                    node.classList.contains('grid') ||
                                    node.querySelector && (
                                        node.querySelector('.product-grid-item') !== null ||
                                        node.querySelector('.grid') !== null
                                    )
                                );
                            });
                            
                            if (hasProductItems) {
                                shouldTrigger = true;
                            }
                        }
                        
                        // Also trigger on removal (filter changes)
                        if (mutation.removedNodes.length > 0) {
                            shouldTrigger = true;
                        }
                    }
                });
                
                if (shouldTrigger) {
                    debouncedInit();
                }
            });

            // Start observing with optimized options
            observer.observe(container, {
                childList: true,
                subtree: true
            });
        });
    }

    /**
     * Initialize EasyLockdown integration
     */
    function init() {
        // Setup observer for product grid changes
        setupProductGridObserver();
        
        // Trigger on initial load (with a small delay to ensure DOM is ready)
        setTimeout(function() {
            initEasyLockdown();
        }, 200);
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        // DOM already loaded
        init();
    }

    // Also listen for page:loaded event (used by some themes for AJAX navigation)
    document.addEventListener('page:loaded', function() {
        setTimeout(function() {
            setupProductGridObserver();
            initEasyLockdown();
        }, 100);
    });

    // Listen for shopify:section:load event (Shopify theme editor)
    document.addEventListener('shopify:section:load', function() {
        setTimeout(function() {
            setupProductGridObserver();
            initEasyLockdown();
        }, 150);
    });
})();
//----- EasyLockdown integration for product grid updates - End -----//